import React from "react"
import { Link as LinkRouter } from "react-router-dom"

import { Button, Grid, Typography, Link } from "@material-ui/core"
import { Add } from "@material-ui/icons"

import Breadcrumb from "@/components/BreadcrumbNew"
import TrackableLinksTable from "@/pages/Admin/TrackableLinks/TrackableLinksTable"

import useStyles from "@/pages/Admin/TrackableLinks/styles"
import { letalkLinks } from "@/utils/link"

const TrackableLinks: React.FC = () => {
	const classes = useStyles()

	return (
		<Grid
			container
			direction="column"
			spacing={6}
		>
			<Grid item>
				<Grid container direction="column" spacing={3}>
					<Grid item>
						<Breadcrumb
							data={[
								{ name: "Links rastreáveis", pathname: "/admin/tools/trackable-links" }
							]}
						/>
					</Grid>

					<Grid item>
						<Grid container direction="column">
							<Grid item>
								<Grid container justifyContent="space-between" alignItems="center" spacing={2}>
									<Grid item>
										<Typography
											variant="h5"
											className={classes.titleText}
										>
											Links Rastreáveis
										</Typography>
									</Grid>
									<Grid item>
										<Button
											variant="contained"
											color="primary"
											component={LinkRouter}
											to={"/admin/tools/trackable-links/create"}
											startIcon={<Add />}
										>
											Adicionar novo link
										</Button>
									</Grid>
								</Grid>
							</Grid>

							<Grid item>
								<Link
									href={letalkLinks.wikiUnderstandWhatTrackableLinksAre}
									className={classes.link}
									underline="always"
									target="_blank"
									color="inherit"
								>
									Entenda o que são links rastreáveis
								</Link>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>

			<Grid item>
				<TrackableLinksTable />
			</Grid>
		</Grid>

	)
}

export default TrackableLinks
